import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AdvSearch, AdvSearchProps } from 'src/app/components/utils/advanced-search/adv_search/adv-search';
import { ITEM_TYPE, SearchParamAdv } from 'src/app/components/utils/advanced-search/advanced-search.component';
import { CSVData, Doctype, FileProps, Invoice, Metadata, PaginatorInvoices, Workflow } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { UserData } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-nso-invoices',
  templateUrl: './nso-invoices.component.html',
  styleUrls: ['./nso-invoices.component.css']
})
export class NsoInvoicesComponent implements OnInit {

  @Input() userInfo: UserData | undefined;

  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
      this.innerWidth = window.innerWidth;
  }

  loading: boolean = false;
  advSearch: AdvSearch = new AdvSearch();
  customSearch: AdvSearchProps = {
          advanced_search: true,
          defaultItemClass: 'col-3',
          header: [
              {
                  id: "select_more",
                  type: ITEM_TYPE.SELECT_MORE,
                  label: "Dati ordine:",
                  nameClass: "col-auto",
                  select_more_values: []
              },
              {
                  id: "state",
                  type: ITEM_TYPE.MULTI_SELECT,
                  label: "Stato",
                  placeholder: "(Tutti)",
                  nameClass: "col-2",
                  multi_select_values: []
              },
              {
                  id: "docCons",
                  type: ITEM_TYPE.SELECT,
                  label: "Documenti conservati",
                  nameClass: "col-2",
                  initValue: "_",
                  select_values: [
                      { key: "_", value: "(tutti)" },
                      { key: "con", value: "Conservati" },
                      { key: "noCons", value: "Non conservati" }
                  ]
              }
          ],
          body: [
              {
                  id: "filename",
                  type: ITEM_TYPE.TEXT,
                  label: "Filtro di ricerca:",
                  placeholder: "Nome file",
                  nameClass: "col-2"
              },
              {
                  id: "dSCreate",
                  type: ITEM_TYPE.DATE_PICKER,
                  label: "Data creazione",
                  placeholder: "Da",
                  nameClass: "col-2"
              },
              {
                  id: "dECreate",
                  type: ITEM_TYPE.DATE_PICKER,
                  placeholder: "a",
                  nameClass: "col-2"
              },
              {
                  id: "docCons",
                  type: ITEM_TYPE.SELECT,
                  label: "Documenti scaricati",
                  nameClass: "col-2",
                  initValue: "_",
                  select_values: [
                      { key: "_", value: "(tutti)" },
                      { key: "s", value: "Scaricati" },
                      { key: "l", value: "Letti" },
                      { key: "ns", value: "Non scaricati" }
                  ]
              },
              {
                  id: "btnClear",
                  type: ITEM_TYPE.BUTTON,
                  label: "Pulisci",
                  nameClass: "col-auto",
                  tooltip: "Ripristina la ricerca di default"
              }
          ]
      };
      
  primaRicerca: boolean = false;
  dataTable: any;

  structureDocType: Doctype | undefined;
  structureWorkflowStates: Workflow[] | undefined;
  params: HttpParams;
  anno: number;

  configProps: ConfigProps | undefined;
  configDoc: Doctype | undefined;

  constructor(private toast: ToastService, private configService: ConfigServiceService) {
    this.innerWidth = window.innerWidth;
    
    this.anno = new Date().getFullYear();

    this.params = new HttpParams();
    this.params = this.params.append('endRow', 0);
    this.params = this.params.append('lastKeyVal', '');
    this.params = this.params.append('page', 1);
    this.params = this.params.append('pageDirection', 'FORWARD');
    this.params = this.params.append('pageSize', 12);
    this.params = this.params.append('pagination', true);
    this.params = this.params.append('paginationMode', 'SKIP');
    this.params = this.params.append('rows', 0);
    this.params = this.params.append('searchFilter', '{}');
    this.params = this.params.append('sortDir', 'DESC');
    this.params = this.params.append('sortKey', 'date_created');
    this.params = this.params.append('startRow', 0);
    this.params = this.params.append('totalPages', -1);
    this.params = this.params.append('totalRows', 0);
  }

  async ngOnInit(): Promise<void> {
    this.configDoc = new UTILS().deepCopy(await this.configService.getDocTypeNso());
    this.structureWorkflowStates = new UTILS().deepCopy(await this.configService.getWorkflowNso());

    this.structureDocType = this.configDoc as Doctype;
    this.structureDocType!.metadata.sort(
      (a: Metadata, b: Metadata) => {
        const order = ['denominazione', 'dataordine', 'numeroordine'];
        const indexA = order.indexOf(((a.name).toLowerCase()).replace(" ", ""));
        const indexB = order.indexOf(((b.name).toLowerCase()).replace(" ", ""));
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        } else if (indexA !== -1) {
            return -1;
        } else if (indexB !== -1) {
            return 1;
        } else {
            return 0;
        }
      }
    );

    const searchFilter = {
      date_created: {
        "0": `${this.anno}-01-01T00:00:00.000Z`,
        "1": `${this.anno}-12-31T23:59:59.999Z`
      }
    };
    const searchFilterStr = JSON.stringify(searchFilter);

    this.params = this.params.delete('searchFilter');
    this.params = this.params.append('searchFilter', searchFilterStr);

    (this.customSearch.body?.forEach(elem => {
                
      if (elem.id == "dSCreate") {
          elem.value = { year: this.anno, month: 8, day: 1 };
      }
      if (elem.id == "dECreate") {
          elem.value = { year: this.anno, month: 8, day: 31 };
      }
    }));

    this.createCloneCustomSearch();
    this.primaRicerca = true;
    await this.getDataTable();
  }

  async searchParams(event: SearchParamAdv) {
    this.dataTable = undefined;
    // METADATI
    let objRequest: any = {};
    try {
      let metadata = new UTILS().deepCopy(this.structureDocType!.metadata.filter(m => m.name == event.header.filter(h => h.id == "select_more")[0].value)[0]);
      if (metadata.data_type != "d") {
        if (event.header.filter(h => h.id == "select_more")[0].child.length > 0) {
          metadata.value = event.header.filter(h => h.id == "select_more")[0].child.filter(c => c.id == event.header.filter(h => h.id == "select_more")[0].value)[0].value;
          if (event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "beetween").length > 0 && event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "beetween")[0].value) {
            //metadata.value = "*" + metadata.value + "*";
            metadata["search_type"] = "LIKE"
          }
        }
      } else {
        metadata.value = []
        if (event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dS").length > 0) {
          let ds = event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dS")[0].value;
          metadata.value.push(ds);
        }
        if (event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dE").length > 0) {
          let de = event.header.filter(h => h.id == "select_more")[0].child.filter(i => i.id == "dE")[0].value;
          metadata.value.push(de);
        }
      }
      objRequest["metadata"] = [metadata];
    } catch (error) { }
    // WORKFLOW_ID + WORKFLOW STATE
    if (event.header.filter(h => h.id == "state").length > 0) {
      //objRequest["workflow_id"] = this.structureDocType!.workflow_id;
      objRequest["workflow_state_code"] = event.header.filter(h => h.id == "state")[0].value.value;
    }
    // CONSERVATI
    if (event.header.filter(h => h.id == "docCons").length > 0 && event.header.filter(h => h.id == "docCons")[0].value != "_") {
      objRequest["conservato"] = event.header.filter(h => h.id == "docCons")[0].value == "con" ? 1 : 0;
    }
    // TITLE - Filename
    if (event.body.filter(h => h.id == "filename").length > 0) {
        objRequest["file_name"] = event.body.filter(h => h.id == "filename")[0].value;
    }
    // date_created - data creazione
    if (event.body.filter(h => h.id == "dSCreate").length > 0) {
      if (!objRequest["date_created"]) {
        objRequest["date_created"] = {};
      }
      objRequest["date_created"]["0"] = event.body.filter(h => h.id == "dSCreate")[0].value;
    }
    if (event.body.filter(h => h.id == "dECreate").length > 0) {
      if (!objRequest["date_created"]) {
        objRequest["date_created"] = {};
      }
      objRequest["date_created"]["1"] = event.body.filter(h => h.id == "dECreate")[0].value;
    }
    // download
    if (event.body.filter(h => h.id == "docCons").length > 0 && event.body.filter(h => h.id == "docCons")[0].value != "_") {
      objRequest["download"] = event.body.filter(h => h.id == "docCons")[0].value == "l" ? 1 : event.body.filter(h => h.id == "docCons")[0].value == "s" ? 2 : 0;
    }
    this.params = this.params.delete('searchFilter');
    this.params = this.params.append('searchFilter', JSON.stringify(objRequest));
    this.primaRicerca = false;
    await this.getDataTable();
  }

  createCloneCustomSearch() {
    if (this.structureWorkflowStates && this.structureWorkflowStates.length > 0) {
      this.customSearch.header.filter(i => i.id == "state")[0].multi_select_values = []
      this.structureWorkflowStates.forEach(e => {
        this.customSearch.header.filter(i => i.id == "state")[0].multi_select_values!.push({ key: e.code, value: e.name })
      });
    }
    if (this.structureDocType) {
      this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values = []
      this.structureDocType.metadata.forEach(m => {
        switch (m.input_type) {
          case "text":
            switch (m.data_type) {
              case "t":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    { id: m.name, type: ITEM_TYPE.TEXT, placeholder: m.label },
                    { id: "beetween", type: ITEM_TYPE.CHECKBOX, tooltip: "Cerca nel mezzo" }
                  ]
                });
                break;
              case "d":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    { id: 'dS', type: ITEM_TYPE.DATE_PICKER, placeholder: 'Da' },
                    { id: 'dE', type: ITEM_TYPE.DATE_PICKER, placeholder: 'a' },
                  ]
                });
                break;
              case "i":
              case "n":
                this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.push({
                  key: m.name,
                  value: m.label,
                  body: [
                    { id: m.name, type: ITEM_TYPE.NUMBER, placeholder: m.label },
                    { id: "beetween", type: ITEM_TYPE.CHECKBOX, tooltip: "Cerca nel mezzo" }
                  ]
                });
                break;
            }
            break;
        }
      });
      if (this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values!.length > 0) {
        this.customSearch.header.filter(i => i.id == "select_more")[0].initValue = this.customSearch.header.filter(i => i.id == "select_more")[0].select_more_values![0].key;
      }
    }
    this.advSearch.setAdvSearch(this.customSearch);
  }

  async callButton(event: { id: string, body: SearchParamAdv }) {
    if (event.id == "btnClear") {
      this.dataTable = undefined;
      this.advSearch.setAdvSearch(this.customSearch);
      this.params = new HttpParams();
      this.params = this.params.append('endRow', 0);
      this.params = this.params.append('lastKeyVal', '');
      this.params = this.params.append('page', 1);
      this.params = this.params.append('pageDirection', 'FORWARD');
      this.params = this.params.append('pageSize', 12);
      this.params = this.params.append('pagination', true);
      this.params = this.params.append('paginationMode', 'SKIP');
      this.params = this.params.append('rows', 0);
      this.params = this.params.append('searchFilter', '{}');
      this.params = this.params.append('sortDir', 'DESC');
      this.params = this.params.append('sortKey', 'date_created');
      this.params = this.params.append('startRow', 0);
      this.params = this.params.append('totalPages', -1);
      this.params = this.params.append('totalRows', 0);
      
      const searchFilter = {
        date_created: {
          "0": `${this.anno}-01-01T00:00:00.000Z`,
          "1": `${this.anno}-12-31T23:59:59.999Z`
        }
      };
    
      const searchFilterStr = JSON.stringify(searchFilter);
  
      this.params = this.params.delete('searchFilter');
      this.params = this.params.append('searchFilter', searchFilterStr);
  
      (this.customSearch.body?.forEach(elem => {
                  
        if (elem.id == "dSCreate") {
          elem.value = { year: this.anno, month: 8, day: 1 };
        }
        if (elem.id == "dECreate") {
          elem.value = { year: this.anno, month: 8, day: 31 };
        }
      }));
  
      this.primaRicerca = true;
        
      await this.getDataTable();
    }
  }

  async getDataTable() {
    this.dataTable = undefined;
    this.dataTable = [];
    this.toast.openToast("Test", "error");
    this.loading = false;
  }

}
